/**
 * @generated SignedSource<<ec4df497fc4cdc8ea1ccc08e7a9187a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamSortField = "DISPLAY_NAME" | "ID" | "IS_VERIFIED" | "STATE";
export type TeamSortOrder = "ASC" | "DESC";
export type TeamSearchFilter = {
  membership?: TeamMembershipFilter | null;
  query?: string | null;
};
export type TeamMembershipFilter = {
  memberIds?: ReadonlyArray<string | null> | null;
};
export type TeamSort = {
  field: TeamSortField;
  order?: TeamSortOrder | null;
};
export type WhereYouWorkSectionWithPreloadedQuery$variables = {
  after?: string | null;
  filter: TeamSearchFilter;
  isTeamSelected: boolean;
  organizationId: string;
  siteId: string;
  sortBy: ReadonlyArray<TeamSort | null>;
  teamId: string;
};
export type WhereYouWorkSectionWithPreloadedQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WhereYouWorkContent_teams">;
};
export type WhereYouWorkSectionWithPreloadedQuery = {
  response: WhereYouWorkSectionWithPreloadedQuery$data;
  variables: WhereYouWorkSectionWithPreloadedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTeamSelected"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v7 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v8 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v9 = {
  "kind": "Variable",
  "name": "organizationId",
  "variableName": "organizationId"
},
v10 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v11 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "kind": "ScalarField",
  "name": "isVerified"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WhereYouWorkSectionWithPreloadedQuery",
    "selections": [
      {
        "args": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "isTeamSelected",
            "variableName": "isTeamSelected"
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "kind": "Variable",
            "name": "teamId",
            "variableName": "teamId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "WhereYouWorkContent_teams"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WhereYouWorkSectionWithPreloadedQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "concreteType": "TeamSearchResultConnectionV2",
            "kind": "LinkedField",
            "name": "teamSearchV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResultV2",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "condition": "isTeamSelected",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "teamId"
                  },
                  (v10/*: any*/)
                ],
                "concreteType": "TeamV2",
                "kind": "LinkedField",
                "name": "teamV2",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "smallAvatarImageUrl"
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "df96fa1d55d3175aaa63d22967b11144",
    "id": null,
    "metadata": {},
    "name": "WhereYouWorkSectionWithPreloadedQuery",
    "operationKind": "query",
    "text": "query WhereYouWorkSectionWithPreloadedQuery(\n  $organizationId: ID!\n  $siteId: String!\n  $filter: TeamSearchFilter!\n  $sortBy: [TeamSort]!\n  $after: String\n  $teamId: ID!\n  $isTeamSelected: Boolean!\n) {\n  ...WhereYouWorkContent_teams_4tdWOR\n}\n\nfragment SelectedTeamView_team_1ZHBkM on Query {\n  team {\n    teamV2(id: $teamId, siteId: $siteId) @include(if: $isTeamSelected) {\n      ...WhereYouWorkNoTeamConnection_entity\n      ...TeamCard_entity\n      id\n    }\n  }\n}\n\nfragment TeamCard_entity on TeamV2 {\n  id\n  displayName\n  smallAvatarImageUrl\n  isVerified\n}\n\nfragment TeamsTab_teams_4tdWOR on Query {\n  ...SelectedTeamView_team_1ZHBkM\n  team @optIn(to: \"Team-search-v2\") {\n    teamSearchV2(organizationId: $organizationId, siteId: $siteId, filter: $filter, sortBy: $sortBy, after: $after, first: 3) {\n      nodes {\n        team {\n          __typename\n          id\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n\nfragment WhereYouWorkContent_teams_4tdWOR on Query {\n  ...WhereYouWorkTabSelector_teams_1hIZ0W\n  ...TeamsTab_teams_4tdWOR\n}\n\nfragment WhereYouWorkNoTeamConnection_entity on TeamV2 {\n  id\n  ...TeamCard_entity\n}\n\nfragment WhereYouWorkTabSelector_teams_1hIZ0W on Query {\n  team @optIn(to: \"Team-search-v2\") {\n    teamSearchV2(organizationId: $organizationId, siteId: $siteId, filter: $filter, sortBy: $sortBy, after: $after, first: 3) {\n      nodes {\n        team {\n          id\n          displayName\n          isVerified\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ff5682673aae581c9a33af26c76ad21";

export default node;
